export default __webpack_public_path__ + "static/media/blank_booking_icon.eaed78ec.svg";